import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ConfiguratorPage from '@/configurator/ConfiguratorPage';
import LibraryPage from '@/library/LibraryPage';
import '@/usability.css';
import '@/configurator/pivot.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter><Routes><Route path="/configure/mt150/*" element={<ConfiguratorPage />} /><Route path="/configure/product/*" element={<ConfiguratorPage />} /><Route path="/library" element={<LibraryPage />} /><Route path="/library/:slug" element={<LibraryPage />} /><Route path="*" element={<App />} /></Routes></BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
